import { createSelector } from '@ngrx/store';
import { OnlineOrders } from '@shared/core/utils';
import { getHistoryOrderByOrderGUID } from '../getHistoryOrderByOrderGUID';

/** Confirmed but not finalized nor cancelled. Might indicate some subphase like sent to kitched or preparing or ready */
export const isHistoryOrderActive = (orderGUID: string) =>
    createSelector(getHistoryOrderByOrderGUID(orderGUID), (order) => {
        if (!order?.data) return null;

        return OnlineOrders.isOrderActive(order.data.Status);
    });
